import React, { useEffect, useState } from 'react';
import "./FoodCard.css";
import axios from 'axios';
import { baseUrl } from '../../../../common/baseUrl';
import FoodModal from '../FoodModal/FoodModal';
import StarRating from './StarRating';
import FoodTypeMark from '../FoodTypeMark';
import { getImageUrl, peekImageUrl } from '../../../../common/imageUrl';
import { isServedNow, describeWindows } from '../../../../common/foodMenu';
import useMinuteOfDay from '../../../../customHooks/useMinuteOfDay';



export default function FoodCard(props) {

    // const [imageUrl,setImageUrl] = useState("");
    // const [loading, setLoading] = useState(true); // Add loading state
    // console.log("Food Card Props : ",props);
    const [quantity, setQuantity] = useState(0); // State to track

    // The kitchen's clock, re-read as the minute rolls over, so an item that leaves its
    // serving window while the guest is browsing greys out without a reload.
    const minuteOfDay = useMinuteOfDay();
    const servedNow = isServedNow(props.availability_windows, minuteOfDay);
    const servingHours = describeWindows(props.availability_windows);
    const isOrderable = props.is_available && servedNow;

    // Seeded from the shared cache so a menu the guest has already seen paints
    // its photos on the first render instead of one request per item.
    const [imageUrl, setImageUrl] = useState(() => peekImageUrl(props.photo) || "");
    const [loading, setLoading] = useState(!imageUrl);


    // Food Item modal
    const [foodItemModal,setFoodItemModal] = useState(false);
    const [selectedFoodItem,setSelectedFoodItem] = useState({
        name : "",
        price : 0,
        desc : "",
        imgURL : "",
        id : "",
        is_bestseller : false,
        is_chef_recommended : false,
    });


    
    // Image Load
    useEffect(() => {
        let isCancelled = false;

        getImageUrl(props.photo)
            .then((url) => {
                if (isCancelled) {
                    return;
                }

                if (url) {
                    setImageUrl(url);
                }

                setLoading(false);
            })
            .catch((error) => {
                console.error(error);

                if (!isCancelled) {
                    setLoading(false);
                }
            });

        return () => {
            isCancelled = true;
        };
    }, [props.photo]);



    // THis is for setting the quantity if go to final page and then come to this page
    useEffect(() => {
        if (props.foodCart.length > 0) {
            const currentItem = props.foodCart.find(item => item.menu_item_id === props.id);
            if (currentItem) {
                setQuantity(currentItem.quantity); // Set the quantity for the current food item
            }
        }
    },[props.foodCart,props.id])

 

    const handleAddToCart = () => {
        // Check if the item is already in the cart
        const itemInCart = props.foodCart.find(item => item.menu_item_id === props.id);

        if (itemInCart) {
            console.log("Item already present in the cart");
        } else {
            // If the item is not in the cart, add it with quantity 1
            setQuantity(1);
            props.setFoodCart([
                ...props.foodCart,
                {
                    menu_item_id: props.id,
                    name: props.name,
                    quantity: 1, // Set the initial quantity to 1
                    price : props.price,
                    gst_percentage : props.gst_percentage
                },
            ]);
        }
    };

    // Increase quantity
    const handleIncreaseQuantity = () => {
        const newQuantity = quantity + 1;
        setQuantity(newQuantity);
        updateCartItemQuantity(props.id, newQuantity);
    };

    // Decrease quantity
    const handleRemoveFromCart = () => {
        if (quantity >= 0) {
            const newQuantity = quantity - 1;
            setQuantity(newQuantity);
            updateCartItemQuantity(props.id, newQuantity);
        }
 
    };
 
    // Update quantity in the cart
    const updateCartItemQuantity = (id, newQuantity) => {
        if (newQuantity === 0) {
            // Remove the item from the cart if quantity is 0
            const updatedCart = props.foodCart.filter(item => item.menu_item_id !== id);
            props.setFoodCart(updatedCart);
        } else {
            // Update the quantity in the cart if it's greater than 0
            const updatedCart = props.foodCart.map(item =>
                item.menu_item_id === id ? { ...item, quantity: newQuantity } : item
            );
            props.setFoodCart(updatedCart);
        }
    };


    const setDataForModal = ()=>{
        try{
            if(loading) return;
            setSelectedFoodItem({
                name : props.name || "",
                price : props.price || 0,
                desc : props.desc || "",
                imgURL : imageUrl || props.photo || "",
                id : props.id || "",
                is_bestseller : props.is_bestseller || false,
                is_chef_recommended : props.is_chef_recommended || false,
            });
            setFoodItemModal(true);

        }catch(error){
            console.log(error);
        }
    }
 
    
    return (
        <>
            <div className="food-data">
                <div className={`food-card ${!isOrderable ? 'unavailable' : ''}`}>

                    {/* Food Data */}
                    <div className="food-card-header">
                        <div className='food-card-marks'>
                            <FoodTypeMark foodType={props.food_type} />
                            {props.is_bestseller && <span className='food-tag bestseller'>Bestseller</span>}
                            {props.is_chef_recommended && <span className='food-tag chef'>Chef's Special</span>}
                        </div>

                        <h3>{props.name || "Food Name"}</h3>

                        {props.average_rating ? (
                            <div className='food-card-rating'>
                                <StarRating rating={props.average_rating} />
                                {props?.number_of_ratings ? <span>({props.number_of_ratings})</span> : null}
                            </div>
                        ) : null}

                        <h5>₹ {props.price || "Price"}</h5>

                        <p>
                            {props?.desc?.length > 70
                                ? props?.desc.substring(0, 70) + "..."
                                : props?.desc || ""}
                        </p>

                        {!props.is_available && <span className='food-unavailable'>Not available</span>}
                        {props.is_available && !servedNow && (
                            <span className='food-unavailable'>
                                {servingHours ? `Available ${servingHours}` : 'Not available now'}
                            </span>
                        )}
                    </div>

                    {/* Food Image and Buttons */}
                    <div className="food-card-img" onClick={()=>setDataForModal()}>
                        {loading ? (
                            // Show shimmer effect while the image is loading
                            <div className="skeleton"></div>
                        ) : (
                            // Show image when fetched
                            <img
                                src={imageUrl || props?.photo}
                                alt=""
                                onError={(e) => { e.currentTarget.style.visibility = "hidden"; }}
                            />
                        )}

                        {quantity<=0 ? (
                            // Show "Add" button initially, and nothing at all while the
                            // item cannot be ordered
                            isOrderable && (
                            <button className="add-btn" onClick={(e)=>{
                                e.stopPropagation()
                                handleAddToCart();
                            }}  >Add</button>
                            )
                        ) : (
                            // Show quantity controls after "Add" is clicked
                            <div className="food-btn-qty" onClick={(e) => e.stopPropagation()}>
                                <button className="minus" onClick={handleRemoveFromCart}>-</button>
                                <button className="qtyNum">{quantity}</button>
                                <button className="plus" onClick={handleIncreaseQuantity}>+</button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {
                foodItemModal && <FoodModal 
                    selectedFoodItem={selectedFoodItem} setSelectedFoodItem={setSelectedFoodItem} 
                    foodItemModal = {foodItemModal}
                    setFoodItemModal = {setFoodItemModal}
                />
            }
        </>
  )
}
